/******************************************************************************

Copyright (c) 2020-2021, Visual Elements

******************************************************************************/

// @format

/** A modal window for the everviz container
 *
 * 
 */

import { isFn } from './../core/highcharts-editor';
import { cr, ap } from './../core/highed.dom';
import OverlayModal from "./../core/highed.overlaymodal";
import EvervizLogin from "./highed.everviz.login";
import EvervizProjects from "./highed.everviz.projects";

export default function(summoner, attributes, fn) {
  let modal = new OverlayModal(false, {
      width: 450,
      height: 300,
      showOnInit: false
    }),
    //We don't always know the summoner at create time..
    sumFn = false,
    container = cr('div', 'everviz-cms-container');
  let evervizLogin = new EvervizLogin(container),
    evervizProjects = new EvervizProjects(container),
    modalBody = modal.getBody();
    
    evervizLogin.on('LinkedAccount', () => {
      //Account is created/linked, show user projects now
      container.innerHTML = '';
      showProjects(true);
    });

    ap(modalBody, container);

  ///////////////////////////////////////////////////////////////////////////

  /** Attach to a new summoner
     *  @memberof highed.ModalEditor
     *  @param nn {domnode} - the new node to attach to
     */
  function attachToSummoner(nn) {
    nn = nn || summoner;

    if (!nn) {
      return;
    }
    
    if (isFn(sumFn)) {
      sumFn();
    }

    container.innerHTML = '';

		if (!locals.everviz_license || locals.everviz_license === '') {
      // Show register/login form
      evervizLogin.show(container);
    } else {
      // Logged in, show projects
			highed.api.updateAPILicenseAndTeam(locals.everviz_license, locals.everviz_team);
      showProjects();
    }

    modal.show();
  }

  function showProjects(resizeModal){
    modal.resize(585, 600);
    if (resizeModal) modal.resizeModal();
    evervizProjects.setCallback(fn);
    evervizProjects.show(container, true, true);
  }

  function doDone() {
    if (isFn(fn)) {
    }
    modal.hide();
  }

  function setCallback(cb) {
    fn = cb;
  }

  attachToSummoner(summoner);

  ///////////////////////////////////////////////////////////////////////////

  return {
    //editor: editor,
    show: modal.show,
    hide: modal.hide,
    //on: editor.on,
    //resize: editor.resize,
    attachToSummoner: attachToSummoner,
    setCallback
  };
};
